export default function Aircon() {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Aircon icon</title>
      <path
        d="M0 0V17.3662C0 20.1721 2.26845 22.4475 5.06582 22.4475H44.9342C47.7315 22.4475 50 20.1721 50 17.3662V0H0ZM45.0517 15.079H4.93653V9.87975H45.0517V15.079Z"
        fill="black"
      />
      <path
        d="M37.6822 28.0005C36.5891 28.8022 36.3658 30.2288 37.1415 31.4785C37.2708 31.6789 37.4118 31.8793 37.5646 32.0562C39.0221 33.86 39.1984 35.7699 38.1758 37.8567C37.5646 39.1064 36.9417 40.3679 36.4833 41.6883C35.3432 44.9541 36.0719 48.1844 38.2581 50H39.9976C41.0907 49.1276 42.125 48.1844 41.4316 46.6164C40.6911 44.9541 40.9849 43.4332 41.7372 41.9005C42.1838 40.9927 42.6305 40.0849 43.0301 39.1535C44.7461 35.145 43.747 31.6081 41.0437 28.4367C40.0799 27.3049 38.787 27.1988 37.6939 28.0005H37.6822Z"
        fill="black"
      />
      <path
        d="M22.7668 27.9651C21.4974 28.8847 21.3446 30.3584 22.5434 31.8911C24.1184 33.9189 24.2595 35.9349 23.0724 38.2103C22.2966 39.6958 21.6619 41.2874 21.2505 42.9144C20.5101 45.8265 21.5209 48.7149 23.4837 50H24.9294C26.7395 48.7503 26.8453 48.1726 26.3869 46.1212C26.1518 45.0483 26.2341 43.834 26.4692 42.7611C26.6925 41.7472 27.3037 40.8276 27.7738 39.8727C29.6897 35.9939 29.1372 32.4098 26.5867 29.0262C25.3996 27.4581 24.0244 27.0691 22.7668 27.9769V27.9651Z"
        fill="black"
      />
      <path
        d="M7.72212 28.0712C6.69955 28.8964 6.51149 30.2287 7.27548 31.4548C7.42827 31.7024 7.60458 31.9264 7.78088 32.1622C9.14431 33.8953 9.33236 35.7344 8.36857 37.7151C7.80439 38.8823 7.25197 40.073 6.75832 41.2756C5.60646 44.0344 5.93556 48.4673 8.46259 49.9999H10.2021C11.2247 49.1393 12.2473 48.1843 11.6008 46.7106C10.8251 44.9304 11.1659 43.327 11.9769 41.7118C12.4118 40.8512 12.835 39.9787 13.2111 39.0827C14.8801 35.1096 13.8575 31.6081 11.2247 28.4484C10.2491 27.2812 8.85046 27.1751 7.74562 28.0712H7.72212Z"
        fill="black"
      />
    </svg>
  );
}
